module.exports = __webpack_public_path__ + "f3e973b9b17ba644cc179a38bc4f03c0.png";